module.exports = __webpack_public_path__ + "img/wbicon-baiyun.cdee9a16.jpg";